import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  changing: false,
  announcementRecipientsLastReloadedAt: new Date()
}

export const actionTypes = {
  Changing: 'announcementRecipients/changing',
  Changed: 'announcementRecipients/changed'
}

export const actionCreators = {
  saveInstitutionRecipient: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.announcementService.saveInstitutionRecipient(input, allowErrorDialog)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },
  removeInstitutionRecipient: (announcementId, id) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.announcementService.removeInstitutionRecipient(announcementId, id, allowErrorDialog)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },
  excludeInstitutionRecipient: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.announcementService.excludeInstitutionRecipient(input, allowErrorDialog)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },
  saveInstitutionGroupRecipient: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.announcementService.saveInstitutionGroupRecipient(input, allowErrorDialog)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },
  removeInstitutionGroupRecipient: (announcementId, id) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.announcementService.removeInstitutionGroupRecipient(announcementId, id, allowErrorDialog)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Changing: return { ...state, changing: true }
    case actionTypes.Changed: return { ...state, changing: false, announcementRecipientsLastReloadedAt: new Date() }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/AnnouncementsRecipients.js